import { Component } from '@angular/core';

@Component({
  selector: 'hf-journal-loader',
  templateUrl: './journal-loader.component.html',
  styleUrls: ['./journal-loader.component.scss']
})
export class JournalLoaderComponent {}
